export * from './search-result.component';
export * from './search-result.module';
